import { FC } from 'react'

type Props = {
  url: string
  size: string
}

const Component: FC<Props> = ({ url, size }) => {
  const webp = `${url}?fm=webp&${size}`
  const avif = `${url}?fm=avif&${size}`
  const fileName = url.split('/').pop()

  return (
    <picture>
      <source srcSet={avif} type="image/avif" />
      <source srcSet={webp} type="image/webp" />
      <img src={url} width="100%" height="100%" alt={fileName} className="rounded-full object-contain h-[96px] w-full bg-white" loading='lazy'/>
    </picture>
  )
}

export default Component
